// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionActions-moduleApplicantDecisionActions__jgO2M";
export { _1 as "ApplicantDecisionActions" }
